<template>
  <span>
    <label :for="filter.paramId" class="sr-only">{{ filter.label }}</label>
    <b-form-input
      v-if="typeof filter.filterData == 'string'"
      :id="filter.paramId"
      v-model="selected"
      :options="dynamicOptions"
      value-field="id"
      text-field="name"
      :placeholder="filter.placeholder"
      @input="inputChecker"
    ></b-form-input>
    <b-form-select
      v-if="typeof filter.filterData == 'object'"
      :id="filter.paramId"
      v-model="selected"
      :options="dynamicOptions"
      value-field="id"
      text-field="name"
      :disabled="dynamicOptions[0].disabled"
      :placeholder="filter.placeholder"
      @change="changeCheckFunction"
    >
    </b-form-select>
  </span>
</template>
<script>
import store from '@/store/'
import { FETCH_FILTER_DATA } from '@/store/actions.type.js'
import { mapState } from 'vuex'
import { SEND_FILTER_SELECTED } from '../../store/actions.type'
import { APP_CONFIG } from '../../config/config'

export default {
  props: {
    filter: {
      type: Object,
      default() {
        return {
          label: '',
          value: '',
        }
      },
    },
  },
  data() {
    return {
      groupFilters: [],
      selected: null,
      dependentActive: false,
      dependentOptions: [],
      dependencyIndex: null,
    }
  },
  computed: {
    dependentParentValue() {
      if (this.filter.dependent) {
        // eslint-disable-next-line
        let parentDependencyIndex = this.searchFilters.filterSettings.findIndex(
          (filter) => filter.paramId === this.filter.dependent
        )
        if (parentDependencyIndex > 0) {
          return this.searchFilters.filterSettings[parentDependencyIndex].selected
        }
      }
      return ''
    },
    childDependencyIndex() {
      return this.searchFilters.filterSettings.findIndex(
        (fil) => fil.dependent === this.filter.paramId
      )
    },
    dependentChildValue() {
      if (this.childDependencyIndex > 0) {
        return this.searchFilters.filterSettings[this.childDependencyIndex].selected
      }
      return ''
    },
    isMulti() {
      if (this.filter.filterData[0] && this.filter.filterData[0].queryValues) return true
      return false
    },
    dynamicOptions() {
      if (this.filter.dependent && this.dependentActive === false) {
        // let opts = [{ disabled: true }]
        // return opts.concat(this.filter.filterData)
        return [{ id: null, name: this.filter.placeholder, disabled: true }]
      }
      if (this.filter.dependent && this.dependentActive === true) {
        return this.dependentOptions
      }
      // Set default place holder
      let opts = [{ id: null, name: 'Please select an option' }]
      // Set if custom
      if (this.filter.placeholder) opts = [{ id: null, name: this.filter.placeholder }]
      if (this.filter.filterData.length > 0) return opts.concat(this.filter.filterData)
      return opts
    },
    // Returns a single when the filter is a multivalue
    multiSelected() {
      let selectedVars = this.filter.filterData.filter((filter) => {
        if (this.selected == filter.id) return filter.queryValues
      })
      if (selectedVars[0]) {
        return selectedVars[0].queryValues
      }
      return {}
    },
    lastSearch() {
      return this.searchFilters.lastSearch
    },
    ...mapState(['searchFilters']),
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.filter.selected == 'clear') {
          this.selected = ''
          if (this.isMulti === true) return this.clearParams()
          this.pushParams()
        }
        // If dependency check if we need to populate the options
        if (this.filter.dependent) {
          this.getOptionsFromApi()
        }
      },
    },
    lastSearch() {
      if (APP_CONFIG.searchType == 'Button') this.pushParams()
    },
  },
  mounted() {
    this.getOptionsFromApi()
    // Create dynamic dependency watch
    this.dependencyWatchCreator()
    this.dependentChildWatchCreator()
    // Check if dependent parent active
    if (this.dependentParentValue.length > 0) this.dependentActive = true
    // Set value
    this.setFromUrl()
    if (this.isMulti === true) this.setMulti()
    this.setOptionsByDependent()
  },
  methods: {
    inputChecker() {
      if (this.selected.length > 2 || this.selected.length < 1) {
        this.changeCheckFunction()
      }
    },
    setFromUrl() {
      if (this.isMulti === false) {
        if (this.$route.query[this.filter.paramId]) {
          this.selected = this.$route.query[this.filter.paramId]
          store.dispatch(SEND_FILTER_SELECTED, {
            paramId: this.filter.paramId,
            selected: this.selected,
          })
        }
      }
    },
    setMulti() {
      const vkeys = Object.keys(this.filter.filterData[0].queryValues)
      const queryParams = Object.keys(this.$route.query)

      let allFounded = vkeys.every((ai) => queryParams.includes(ai))
      if (allFounded === true) {
        let valId = this.filter.filterData.filter((filter) => {
          let pass = true
          for (const [k, value] of Object.entries(filter.queryValues)) {
            if (this.$route.query[k] != value) return (pass = false)
          }
          if (pass == true) return filter.id
        })
        this.selected = valId[0].id
        store.dispatch(SEND_FILTER_SELECTED, {
          paramId: this.filter.paramId,
          selected: valId[0].id,
        })
      }
    },
    setOptionsByDependent() {
      if (this.filter.denpdencyData) {
        let dependentSelected = this.searchFilters.filterSettings[this.dependencyIndex].selected
        this.dependentOptions = this.filter.denpdencyData[dependentSelected]
      }
      if (!this.filter.denpdencyData) {
        this.dependentOptions = this.filter.filterData
      }
    },
    getOptionsFromApi() {
      if (this.filter.apiParamName) {
        if (this.filter.filterData.length < 1) {
          store
            .dispatch(FETCH_FILTER_DATA, this.filter.apiParamName)
            .then(() => {
              this.setFromUrl()
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }
    },
    // Set selected and puch vars to url
    pushParams() {
      store.dispatch(SEND_FILTER_SELECTED, {
        paramId: this.filter.paramId,
        selected: this.selected,
      })

      let query = Object.assign({}, this.$route.query)
      // Unset
      if (this.selected == '' && query[this.filter.paramId]) {
        delete query[this.filter.paramId]
        return this.$router.push({ path: this.$route.path, query: query })
      }

      if (!this.filter.ignore) {
        query[this.filter.paramId] = this.selected
        if (this.isMulti === true) {
          let mQuery = Object.assign({}, this.multiSelected)
          let urlQuery = Object.assign({}, this.$route.query)
          let fullQuery = Object.assign(urlQuery, mQuery)
          query = fullQuery
        }

        if (query.include) delete query.include

        if (this.selected !== '') {
          return this.$router.push({ path: this.$route.path, query: query })
        }
      }
    },
    // Clear a parameter
    clearParams() {
      let query = Object.assign({}, this.$route.query)

      // eslint-disable-next-line
      for (const [k, value] of Object.entries(this.filter.filterData)) {
        // eslint-disable-next-line
        for (const [key, v] of Object.entries(value.queryValues)) {
          if (query[key]) delete query[key]
        }
      }
      this.$router.push({ path: this.$route.path, query: query })

      return store.dispatch(SEND_FILTER_SELECTED, {
        paramId: this.filter.paramId,
        selected: '',
      })
    },
    /**
     * We check the search type and perform the apropriate action
     *
     * @return void
     */
    changeCheckFunction() {
      if (this.isMulti) this.clearParams()
      if (APP_CONFIG.searchType == 'Change') this.pushParams()
    },
    dependencyWatchCreator() {
      if (this.filter.dependent) {
        this.dependencyIndex = this.searchFilters.filterSettings.findIndex(
          (filter) => filter.paramId == this.filter.dependent
        )
        this.$watch(
          '$store.state.searchFilters.filterSettings.' + this.dependencyIndex + '.selected',
          function (value) {
            if (value !== '') {
              this.dependentActive = true
              this.setOptionsByDependent()
            }
            if (value === '') this.dependentActive = false
          },
          { deep: true }
        )
      }
    },
    dependentChildWatchCreator() {
      if (this.childDependencyIndex > 0) {
        this.$watch(
          '$store.state.searchFilters.filterSettings.' + [this.childDependencyIndex] + '.selected',
          function () {
            let valueKey = ''
            let depData = this.searchFilters.filterSettings[this.childDependencyIndex].denpdencyData
            // Loop through the dep data to find the parent key
            if (typeof depData == 'object') {
              for (const [key, value] of Object.entries(depData)) {
                if (typeof value === 'object') {
                  let find = depData[key].filter((val) => {
                    return val.id == this.dependentChildValue
                  })
                  if (find.length > 0) valueKey = key
                }
              }
              // Dispatch selected
              this.selected = valueKey
              store.dispatch(SEND_FILTER_SELECTED, {
                paramId: this.filter.paramId,
                selected: this.selected,
              })
            }
          }
        )
      }
    },
  },
}
</script>
